
// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
 apiKey: "AIzaSyDyGVPHnTVyWimYSzCpGmMF_RMm1gxhpW4",
  authDomain: "pitics.com",
  projectId: "piticsjgat",
  storageBucket: "piticsjgat.firebasestorage.app",
  messagingSenderId: "898712575285",
  appId: "1:898712575285:web:cc5d6b753ae1597b38807c"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
